import React, { useState, useEffect } from "react";
import { CustomButton } from "components/CustomComponents/CustomButton";
import * as Mui from "@mui/material";
import { showToast } from "services/utils/Status";
import { checkEditorPermission } from "services/utils/HelperFunction";
import { useFetch } from "services/hooks/useFetch";
import { setGlobalSearchValue } from "services/Redux/userToken";
import { customGetAPI } from "services/utils/CustomAPI";
import { useDispatch, useSelector } from "react-redux";
import { PayingUnit } from "./PayScreen/PayingUnit";
import { GroupUnit } from "./GroupScreen/GroupUnit";
import { AssignUnit } from "./AssignScreen/AssignUnit";
import { CustomAutoComplete } from "components/CustomComponents/CustomAutoComplete";
import { themes, defaultAllSelection } from "services/constants";
import {
  setDepartmentId,
  setDepartmentName,
} from "services/Redux/userManagament";
import { rowEndStyle } from "services/constants/Styles";

export const WorkUnit = () => {
  const { departmentId, departmentName } = useSelector(
    (state) => state.userReducer
  );
  const [groupUnit, setGroupUnit] = useState(false);
  const [showTopBar, setShowTopBar] = useState(true);
  const [workUnit, setWorkUnit] = useState("Pay");
  const [selectComponent, setSelectComponent] = useState("Pay");
  const { domain, token, userScreenAccess } = useSelector(
    (state) => state.tokenReducer
  );
  const [payUnit, setPayUnit] = useState(false);
  const [editWorkUnitPay, setEditWorkUnitPay] = useState(false);
  const [editAssignUnit, setEditAssignUnit] = useState(false);
  const [departmentData, setDepartmentData] = useState([]);
  const [assignGroupUnit, setAssignGroupUnit] = useState(false);
  const [refreshCall, setRefreshCall] = useState(false);
  const {
    result: workUnitGroup,
    setLoad: reCallApi,
    loading,
  } = useFetch(`${domain}work_unit_groups/?department=${departmentId}`);
  const dispatch = useDispatch();
  const handleChange = (event, newAlignment) => {
    if (newAlignment) {
      setWorkUnit(newAlignment);
      dispatch(setGlobalSearchValue(""));
    }
  };

  useEffect(() => {
    dispatch(setDepartmentName("All"));
    dispatch(setDepartmentId(99999));
  }, [dispatch]);

  useEffect(() => {
    const fetchDepartmentData = async () => {
      const res = await customGetAPI(`${domain}work-unit-department/`);
      if (res.ok) {
        const allDepartment = {
          id: defaultAllSelection,
          department: "All",
        };
        setDepartmentData([allDepartment, ...res?.responseDetails]);
      }
    };
    fetchDepartmentData();
  }, [domain, token]);

  const renderComponent = () => {
    switch (selectComponent) {
      case "Pay":
        return (
          <PayingUnit
            payUnit={payUnit}
            setPayUnit={setPayUnit}
            editWorkUnitPay={editWorkUnitPay}
            setEditWorkUnitPay={setEditWorkUnitPay}
            setShowTopBar={setShowTopBar}
            departmentId={departmentId}
            refreshCall={refreshCall}
            selectComponent={selectComponent}
            setRefreshCall={setRefreshCall}
          />
        );
      case "Group":
        return (
          <GroupUnit
            groupUnit={groupUnit}
            departmentId={departmentId}
            workUnitGroup={workUnitGroup}
            reCallApi={reCallApi}
            loading={loading}
            setShowTopBar={setShowTopBar}
            setGroupUnit={setGroupUnit}
          />
        );
      case "Assign":
        return (
          <AssignUnit
            assignGroupUnit={assignGroupUnit}
            setAssignGroupUnit={setAssignGroupUnit}
            editAssignUnit={editAssignUnit}
            setEditAssignUnit={setEditAssignUnit}
            setShowTopBar={setShowTopBar}
            departmentId={departmentId}
            refreshCall={refreshCall}
            selectComponent={selectComponent}
            setRefreshCall={setRefreshCall}
          />
        );
      default:
        break;
    }
  };

  const updateDepartmentName = (event, data) => {
    if (data) {
      dispatch(setDepartmentName(data.label));
      dispatch(setDepartmentId(data.id));
      localStorage.setItem("approveLeaveDepartmentId", data.id);
      localStorage.setItem("approveLeaveDepartmentName", data.label);
      if (selectComponent === "Pay") {
        setRefreshCall(true);
      } else if (selectComponent === "Group") {
        reCallApi(true);
      } else {
        setRefreshCall(true);
      }
    }
  };

  return (
    <React.Fragment>
      <Mui.Grid container sx={{ paddingTop: 2, paddingLeft: 1 }}>
        {showTopBar ? (
          <>
            <Mui.Grid item xs={5}>
              <Mui.Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: 400,
                  borderRadius: 3,
                  height: 55,
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                <Mui.ToggleButtonGroup
                  value={workUnit}
                  exclusive
                  onChange={handleChange}
                  sx={{
                    display: "flex",
                    width: "100%",
                    height: "100%",
                    position: "absolute",
                    borderRadius: 3,
                    backgroundColor: themes.lightBrown,
                  }}
                >
                  <Mui.ToggleButton
                    value="Pay"
                    sx={{
                      flex: 1,
                      textTransform: "capitalize",
                      fontSize: 18,

                      fontWeight: 600,
                      border: "none",
                      color:
                        workUnit === "Pay"
                          ? themes.whiteColor
                          : themes.headLine,
                      backgroundColor:
                        workUnit === "Pay"
                          ? themes.headLine
                          : themes.lightBrown,
                      "&.Mui-selected": {
                        backgroundColor: themes.headLine,
                        color: themes.whiteColor,
                        "&:hover": {
                          backgroundColor: themes.headLine,
                          color: themes.whiteColor,
                        },
                      },
                      "&:hover": {
                        backgroundColor:
                          workUnit === "Pay"
                            ? themes.headLine
                            : themes.lightBrown,
                        color:
                          workUnit === "Pay"
                            ? themes.whiteColor
                            : themes.headLine,
                      },
                    }}
                    onClick={() => setSelectComponent("Pay")}
                  >
                    Pay
                  </Mui.ToggleButton>
                  <Mui.ToggleButton
                    value="Group"
                    sx={{
                      flex: 1,
                      textTransform: "capitalize",
                      fontSize: 18,
                      fontWeight: 600,
                      borderRadius: 3,
                      border: "none",
                      color:
                        workUnit === "Group"
                          ? themes.whiteColor
                          : themes.headLine,
                      backgroundColor:
                        workUnit === "Group"
                          ? themes.headLine
                          : themes.lightBrown,
                      "&.Mui-selected": {
                        backgroundColor: themes.headLine,
                        color: themes.whiteColor,
                        "&:hover": {
                          backgroundColor: themes.headLine,
                          color: themes.whiteColor,
                        },
                      },
                      "&:hover": {
                        backgroundColor:
                          workUnit === "Group"
                            ? themes.headLine
                            : themes.lightBrown,
                        color:
                          workUnit === "Group"
                            ? themes.whiteColor
                            : themes.headLine,
                      },
                    }}
                    onClick={() => setSelectComponent("Group")}
                  >
                    Group
                  </Mui.ToggleButton>
                  <Mui.ToggleButton
                    value="Assign"
                    sx={{
                      flex: 1,
                      textTransform: "capitalize",
                      fontSize: 18,
                      fontWeight: 600,
                      borderRadius: 3,
                      border: "none",
                      color:
                        workUnit === "Assign"
                          ? themes.whiteColor
                          : themes.headLine,
                      backgroundColor:
                        workUnit === "Assign"
                          ? themes.headLine
                          : themes.lightBrown,
                      "&.Mui-selected": {
                        backgroundColor: themes.headLine,
                        color: themes.whiteColor,
                        "&:hover": {
                          backgroundColor: themes.headLine,
                          color: themes.whiteColor,
                        },
                      },
                      "&:hover": {
                        backgroundColor:
                          workUnit === "Assign"
                            ? themes.headLine
                            : themes.lightBrown,
                        color:
                          workUnit === "Assign"
                            ? themes.whiteColor
                            : themes.headLine,
                      },
                      "&:focus": {
                        backgroundColor:
                          workUnit === "Assign"
                            ? themes.headLine
                            : themes.lightBrown,
                        color:
                          workUnit === "Assign"
                            ? themes.whiteColor
                            : themes.headLine,
                      },
                    }}
                    onClick={() => setSelectComponent("Assign")}
                  >
                    Assign
                  </Mui.ToggleButton>
                </Mui.ToggleButtonGroup>
              </Mui.Box>
            </Mui.Grid>
            <Mui.Grid xs={7}>
              <Mui.Grid container sx={{ paddingTop: 1 }}>
                <Mui.Grid xs={6}></Mui.Grid>
                <Mui.Grid
                  xs={6}
                  sx={{
                    ...rowEndStyle,
                    paddingRight: 0.5,
                  }}
                >
                  <Mui.Grid container>
                    <Mui.Grid xs={6} sx={{ paddingRight: 1 }}>
                      <CustomAutoComplete
                        dataList={departmentData?.map((obj) => ({
                          ...obj,
                          label: obj.department,
                        }))}
                        selectedValue={departmentName}
                        updateDataFunction={updateDepartmentName}
                        placeHolder="Select department name"
                        label="Select Department Name"
                      />
                    </Mui.Grid>
                    <Mui.Grid xs={6}>
                      {selectComponent === "Pay" ? (
                        <CustomButton
                          actionFuntion={() => {
                            if (
                              checkEditorPermission(
                                userScreenAccess?.module_details,
                                "Work Unit",
                                "Pay"
                              )
                            ) {
                              setPayUnit(true);
                              setShowTopBar(false);
                            } else {
                              showToast(
                                "error",
                                `Access denied: You are not authorized to add work unit pay`
                              );
                            }
                          }}
                          actionName="Add WorkUnit Pay"
                          typeName="button"
                        />
                      ) : selectComponent === "Group" ? (
                        <CustomButton
                          actionFuntion={() => {
                            if (
                              checkEditorPermission(
                                userScreenAccess?.module_details,
                                "Work Unit",
                                "Group"
                              )
                            ) {
                              setShowTopBar(false);
                              setGroupUnit(true);
                            } else {
                              showToast(
                                "error",
                                `Access denied: You are not authorized to add work unit group`
                              );
                            }
                          }}
                          actionName="Add WorkUnit Group"
                          typeName="button"
                        />
                      ) : (
                        <CustomButton
                          actionFuntion={() => {
                            if (
                              checkEditorPermission(
                                userScreenAccess?.module_details,
                                "Work Unit",
                                "Assign"
                              )
                            ) {
                              setShowTopBar(false);
                              setAssignGroupUnit(true);
                            } else {
                              showToast(
                                "error",
                                `Access denied: You are not authorized to add work unit group`
                              );
                            }
                          }}
                          actionName="Assign WorkUnit Group"
                          typeName="button"
                        />
                      )}
                    </Mui.Grid>
                  </Mui.Grid>
                </Mui.Grid>
              </Mui.Grid>
            </Mui.Grid>
          </>
        ) : null}
      </Mui.Grid>
      {renderComponent()}
    </React.Fragment>
  );
};
